import { Card, Select, TextField } from "@mui/material";
import "./SchoolsUniversityBasicInformation.scss";
import { Field, Formik } from "formik";
import * as yup from "yup";
import { useEffect, useMemo, useRef, useState } from "react";
import { GoogleMap, Marker, MarkerF, useLoadScript, useJsApiLoader } from "@react-google-maps/api";
import {
  ADMIN_ROLES,
  API_RESPONSE,
  I18_TRANSLATION_COMMON,
  MODES,
  NUMBER_CONSTANTS,
  REGISTRATION_FORM,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
  TOKENS,
} from "../../../../Utilities/Constants/Constants";
import { useTranslation } from "react-i18next";
import {
  ERROR_MESSAGES,
  REGEX,
  REGISTRATION_ERRORS,
} from "../../../../Utilities/Constants/Validations";
import { MenuItem } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { format } from "date-fns";
import { REGISTRATION_MODEL } from "../../../../Utilities/Models/ConstantModels";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { GetSessionStorageData, S3DataGetApi, SetSessionStorageData, checkValueNullUndefinedEmpty, numberOnly, uploadFileToS3 } from "../../../../Services/Helpers/Helper";
import { toast } from "react-toastify";
import Autocomplete from "react-google-autocomplete";
import RoomIcon from '@mui/icons-material/Room';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import FileViewerDialog from "../../../../Shared/FileViewerDialog/FileViewerDialog";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloseIcon from "@mui/icons-material/Close";
import closeIcon from "../../../../../Assets/Sessions/close.svg";
import { useSelector } from "react-redux";

const libraries: any = ['places'];
const SchoolsUniversityBasicInformation = (props: any) => {
  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });
  const { isLoaded }: any = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
    libraries
  });
  const geocoder: any = isLoaded ? new window.google.maps.Geocoder() : '';
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [mode, setMode] = useState(MODES.EDIT);
  const [userType, setuserType]: any = useState("");
  const [currentGender, setCurrentGender] = useState("");
  const [phoneNumber, setPhoneNumber]: any = useState("");
  const [validPhoneNumber, setValidPhoneNumber] = useState(API_RESPONSE.TRUE);
  const [loginType, setLoginType]: any = useState("");
  const [initialRender, setInitialRender] = useState(API_RESPONSE.TRUE);
  const [basicInformation, setBasicInformation]: any = useState({});
  const [aboutMeField, setAboutMeField] = useState("");
  const [currentLocation, setCurrentLocation]: any = useState();
  const [mapEnabled, setMapEnabled] = useState(false);
  const uploadDisplayImage = useRef<HTMLInputElement | null>(null);
  const [authorityDocument, setAuthorityDocument]: any = useState("");
  const [fileViewerOpen, setFileViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(API_RESPONSE.FALSE);
  const [phoneNumberTouched, setPhoneNumberTouched] = useState(API_RESPONSE.FALSE)
  let validationSchema = {
    [REGISTRATION_FORM.NAME]: yup
      .string()
      .min(NUMBER_CONSTANTS.FOUR)
      .required(
        userType === ADMIN_ROLES.SCHOOL ? REGISTRATION_ERRORS.SCHOOL_NAME : REGISTRATION_ERRORS.UNIVERSITY_NAME,
      )
      .trim(),
    [REGISTRATION_FORM.AUTHORITY_NAME]: yup
      .string()
      .min(NUMBER_CONSTANTS.FOUR)
      .required(REGISTRATION_ERRORS.AUTHORITY_NAME)
      .trim(),
    [REGISTRATION_FORM.AUTHORITY_EMAIL]: yup
      .string()
      .required(ERROR_MESSAGES.AUTHORITY_EMAIL_REQUIRED)
      .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .email(ERROR_MESSAGES.INVALID_EMAIL),
    [REGISTRATION_FORM.EMAIL]: yup
      .string()
      .required(ERROR_MESSAGES.EMAIL_REQUIRED)
      .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .email(ERROR_MESSAGES.INVALID_EMAIL),
    [REGISTRATION_FORM.PHONE]: yup.string().required(ERROR_MESSAGES.PHONE_NUMBER),
    [REGISTRATION_FORM.ADDRESS]: yup.string().required(REGISTRATION_ERRORS.ADDRESS),
    [REGISTRATION_FORM.CITY]: yup.string().required(REGISTRATION_ERRORS.CITY),
    [REGISTRATION_FORM.STATE]: yup.string().required(REGISTRATION_ERRORS.STATE),
    [REGISTRATION_FORM.PINCODE]: yup.string().required(REGISTRATION_ERRORS.PINCODE),
    [REGISTRATION_FORM.COUNTRY]: yup.string().required(REGISTRATION_ERRORS.COUNTRY),
    [REGISTRATION_FORM.COUNTRY_CODE]: yup.string().required(REGISTRATION_ERRORS.COUNTRY_CODE)

  }
  const [initialValue, setInitialValue]: any = useState({
    [REGISTRATION_FORM.NAME]: "",
    [REGISTRATION_FORM.AUTHORITY_NAME]: "",
    [REGISTRATION_FORM.AUTHORITY_EMAIL]: "",
    [REGISTRATION_FORM.EMAIL]: "",
    [REGISTRATION_FORM.PHONE]: "",
    // roles: "",
    [REGISTRATION_FORM.ADDRESS]: "",
    [REGISTRATION_FORM.CITY]: "",
    [REGISTRATION_FORM.STATE]: "",
    [REGISTRATION_FORM.PINCODE]: "",
    [REGISTRATION_FORM.COUNTRY]: "",
    [REGISTRATION_FORM.COUNTRY_CODE]: "",
    [REGISTRATION_FORM.LATITUDE]: "",
    [REGISTRATION_FORM.LONGITUDE]: ""
  });

  useEffect(() => {
    setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));

  }, []);


  useEffect(() => {
    // Get current user's location using the browser's Geolocation API
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCurrentLocation({ lat: latitude, lng: longitude });
        },
      );
    }
  }, [])

  useEffect(() => {
    if (userType)
      getRegistrationDetail(API_END_POINTS.SCHOOL_UNIVERSITY_DETAILS);

  }, [userType])


  const getRegistrationDetail = (END_POINTS: any) => {

    if (GetSessionStorageData(TOKENS.TEMPORARY_TOKEN)) {
      axiosInstance.get(END_POINTS).then((response) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          setBasicInformation(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
          let data = response.data.result.data[NUMBER_CONSTANTS.ZERO];
          setInitialValue({
            [REGISTRATION_FORM.NAME]: data.name,
            [REGISTRATION_FORM.AUTHORITY_NAME]: data.authority_name,
            [REGISTRATION_FORM.AUTHORITY_EMAIL]: data.authority_email,
            [REGISTRATION_FORM.EMAIL]: data.email,
            [REGISTRATION_FORM.PHONE]: data.authority_phonenumber,
            [REGISTRATION_FORM.ADDRESS]: data.address,
            [REGISTRATION_FORM.CITY]: data.city,
            [REGISTRATION_FORM.STATE]: data.state,
            [REGISTRATION_FORM.PINCODE]: data.pincode,
            [REGISTRATION_FORM.COUNTRY]: data.country,
            [REGISTRATION_FORM.COUNTRY_CODE]: data.country_code,
            [REGISTRATION_FORM.LATITUDE]: data.latitude,
            [REGISTRATION_FORM.LONGITUDE]: data.longitude,
            [REGISTRATION_FORM.LATITUDE]: data.latitude,
            [REGISTRATION_FORM.LONGITUDE]: data.longitude
          });
          setAuthorityDocument(data.authority_doc);
          setPhoneNumber(data.authority_phonenumber)
        }
      })
    }

  }

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      setLoginType(GetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE));
    }
    setLoginType(GetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE));
  }, []);

  useEffect(() => {
    if (loginType === `${NUMBER_CONSTANTS.ONE}`) {
      initialValue.authority_email = GetSessionStorageData(STORAGE_KEYS.EMAIL)
    } else {
      initialValue.phone = GetSessionStorageData(STORAGE_KEYS.PHONE_NUMBER);
      setPhoneNumber(GetSessionStorageData(STORAGE_KEYS.PHONE_NUMBER) || '');
    };
  }, [loginType])


  useEffect(() => {
    props.currentMode ? setMode(props.currentMode) : setMode(MODES.EDIT);
  }, []);



  /* yup validation schema */
  const formValidationSchema = yup.object(validationSchema);

  /* Validate phone number */
  const validatePhoneNumber = (e: any) => {
    isValidPhoneNumber(e);
    isValidPhoneNumber(e) === API_RESPONSE.TRUE
      ? setValidPhoneNumber(API_RESPONSE.TRUE)
      : setValidPhoneNumber(API_RESPONSE.FALSE);
    return isValidPhoneNumber(e);
  };

  /* Navigate call */
  const onNavigate = (state: any) => {
    props.activeStatus(state);
  };

  /* Update gender state */
  const onSelectGender = (event: any) => {
    setCurrentGender(event.target.value);
  };

  /* Handling tokens */
  const responseAction = (response: any) => {
    return new Promise((resolve, reject) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        SetSessionStorageData(
          TOKENS.TEMPORARY_TOKEN,
          response.data.result.data.access_token
        );
        SetSessionStorageData(
          TOKENS.REFRESH_TOKEN,
          response.data.result.data.refresh_token
        );
        //navigate(ROUTES.DASHBOARD);
        toast.success(response.data.message, TOASTER_CONFIGS);
        resolve(API_RESPONSE.TRUE);
      }
    })
  };

  const onRegister = (payload: any, API: any) => {
    setFormSubmitted(API_RESPONSE.FALSE);
    if (basicInformation && GetSessionStorageData(TOKENS.TEMPORARY_TOKEN)) {
      axiosInstance
        .put(API, payload)
        .then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            responseAction(response);
            onNavigate(NUMBER_CONSTANTS.TWO);
          }
        });
    } else {
      axiosInstance
        .post(API, payload)
        .then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            responseAction(response);
            onNavigate(NUMBER_CONSTANTS.TWO);
          }
        });
    }

  };

  const handleImageChange = async (event: any) => {
    const uploadedImage = await S3DataGetApi(event);
    setAuthorityDocument(uploadedImage);
  }

  /**Handle file viwer dialog close */
  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(API_RESPONSE.FALSE);
    setViewerFile("");
  };

  /**Handle file viwer dialog open */
  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(true);
  };

  const setCurrentLatLng = (latitude: any, longitude: any) => {
    setCurrentLocation({ lat: latitude, lng: longitude });
  }

  const setAddressData = (address: any, formik: any) => {
    address.forEach((component: any) => {
      const componentType = component.types[0];

      switch (componentType) {
        // case 'locality':
        case 'administrative_area_level_3':
          formik.setFieldValue(REGISTRATION_FORM.CITY, component.long_name)
          break;
        case 'administrative_area_level_1':
          formik.setFieldValue(REGISTRATION_FORM.STATE, component.long_name)
          break;
        case 'country':
          formik.setFieldValue(REGISTRATION_FORM.COUNTRY, component.long_name)
          break;

        case 'postal_code':
        case 'postal_code_prefix':
          formik.setFieldValue(REGISTRATION_FORM.PINCODE, component.long_name)
          break;
        default:
          break;
      };
    });
  }

  const getFormattedAddress = (lat: any, lng: any, formik: any) => {
    geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
      if (status === API_RESPONSE.OK) {
        if (results[NUMBER_CONSTANTS.ZERO]) {
          formik.setFieldValue(
            REGISTRATION_FORM.ADDRESS,
            results[NUMBER_CONSTANTS.ZERO].formatted_address
          )
          setAddressData(results[NUMBER_CONSTANTS.ZERO].address_components, formik)
        }
      }
    });
  }


  /* Submit API call */
  const onSaveBasicInformation = (payload: any) => {
    if (validatePhoneNumber(phoneNumber?.split("+").length > 1 ? phoneNumber : "+" + phoneNumber)) {
      payload.roles = GetSessionStorageData(STORAGE_KEYS.ROLE);
      payload.id = GetSessionStorageData(STORAGE_KEYS.ID);
      payload.latitude = `${currentLocation.lat}`;
      payload.longitude = `${currentLocation.lng}`;
      payload.authority_doc = authorityDocument;
      if (userType === ADMIN_ROLES.SCHOOL) {
        payload.type_info = `${NUMBER_CONSTANTS.ONE}`;
        onRegister(payload, API_END_POINTS.SCHOOL_UNIVERSITY_REGISTRATION);
      } else {
        payload.type_info = `${NUMBER_CONSTANTS.TWO}`;
        onRegister(payload, API_END_POINTS.SCHOOL_UNIVERSITY_REGISTRATION);
      }
    }


  };

  return (
    <div className="row bi-wrapper">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

        <FileViewerDialog
          open={fileViewerOpen}
          handleClose={onFilerViewerDialogClose}
          viewerFile={viewerFile}
        ></FileViewerDialog>
        <Card
          className={
            mode === MODES.VIEW ? "bi-card-wrapper-view" : "bi-card-wrapper"
          }
        >
          <Formik
            initialValues={initialValue}
            enableReinitialize={true}
            validationSchema={formValidationSchema}
            onSubmit={(values, actions) => {
              onSaveBasicInformation(values);
            }}
          >
            {(formik: any) => {
              return (
                <div>
                  <h4 className="header-title">Basic Information</h4>
                  <div className="row row-wrap">
                    <div className="col-md-12">
                      <div className="form-items">
                        <label className="form-label">{t(userType === ADMIN_ROLES.SCHOOL ? "School name" : "University Name")}</label>
                        <Field
                          name={REGISTRATION_FORM.NAME}
                          className="email-input"
                          placeholder={t(userType === ADMIN_ROLES.SCHOOL ? "School name" : "University Name")}
                          disabled={mode === MODES.VIEW ? true : false}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.NAME] &&
                            formik.errors[REGISTRATION_FORM.NAME] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.NAME]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t(userType === ADMIN_ROLES.SCHOOL ? "School Email" : "University Email")}</label>
                        <Field
                          name={REGISTRATION_FORM.EMAIL}
                          className="email-input"
                          placeholder={t("Email")}
                          disabled={mode === MODES.VIEW ? true : false}
                        //   disabled={loginType === `${NUMBER_CONSTANTS.ONE}` ?  true : false}    
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.EMAIL] &&
                            formik.errors[REGISTRATION_FORM.EMAIL] ? (
                            <p>
                              {t(`${formik.errors[REGISTRATION_FORM.EMAIL]}`)}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("Authority name")}</label>
                        <Field
                          name={REGISTRATION_FORM.AUTHORITY_NAME}
                          className="email-input"
                          placeholder={t("Authority name")}
                          disabled={mode === MODES.VIEW ? true : false}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.AUTHORITY_NAME] &&
                            formik.errors[REGISTRATION_FORM.AUTHORITY_NAME] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.AUTHORITY_NAME]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("Authority Email")}</label>
                        <Field
                          name={REGISTRATION_FORM.AUTHORITY_EMAIL}
                          className="email-input"
                          placeholder={t("Authority Email")}
                          // disabled={mode === MODES.VIEW ? true : false}
                          disabled={loginType === `${NUMBER_CONSTANTS.ONE}` ? true : false}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.AUTHORITY_EMAIL] &&
                            formik.errors[REGISTRATION_FORM.AUTHORITY_EMAIL] ? (
                            <p>
                              {t(`${formik.errors[REGISTRATION_FORM.AUTHORITY_EMAIL]}`)}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">
                          {t("Phone Number")}
                        </label>
                        <PhoneInput
                          inputProps={{
                            className: "input phone_num_input",
                          }}
                          country={"ae"}
                          enableSearch={true}
                          value={phoneNumber}
                          // onBlur={(e:any) => {
                          //   setPhoneNumberTouched(true);
                          //   validatePhoneNumber("+" + e)
                          // }}
                          onBlur={formik.handleBlur("phone_num_input")}
                          disabled={loginType === `${NUMBER_CONSTANTS.ZERO}` ? true : false}
                          onChange={(e: any, country: any) => {
                            setPhoneNumber(e);
                            validatePhoneNumber("+" + e);
                            formik.setFieldValue(
                              REGISTRATION_FORM.PHONE,
                              "+" + e
                            );
                            formik.setFieldValue(
                              REGISTRATION_FORM.COUNTRY_CODE,
                              "+" + country.dialCode
                            )
                          }}
                          countryCodeEditable={false}
                        />
                        <div className="errorMessage">
                          {phoneNumberTouched &&
                            validPhoneNumber === false && (

                              <p>
                                {t(
                                  `${ERROR_MESSAGES.PHONE_NUMBER
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                        {/* <div className="errorMessage">
                          {validPhoneNumber === false && (
                            <p>{t(`Please enter valid phone number`)}</p>
                          )}
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="row row-wrap">

                    <div className="col-md-12">
                      <div className="form-items">
                        <label className="form-label">{t("Address")}</label>
                        <div className="address-wrapper">
                          {isLoaded && <Autocomplete
                            apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                            value={formik.values[REGISTRATION_FORM.ADDRESS]}
                            onBlur={formik.handleBlur}
                            onChange={(e: any) => {
                              formik.setFieldValue(REGISTRATION_FORM.ADDRESS, e.target.value)
                            }}

                            onPlaceSelected={(place: any) => {
                              setCurrentLatLng(place.geometry.location.lat(), place.geometry.location.lng());
                              getFormattedAddress(place.geometry.location.lat(), place.geometry.location.lng(), formik);
                            }}
                          />}
                          {mapEnabled && <RoomIcon className="room-icon" onClick={() => { setMapEnabled(!mapEnabled) }} />}
                          {!mapEnabled && <LocationOffIcon className="room-icon" onClick={() => { setMapEnabled(!mapEnabled) }} />}
                        </div>

                        {isLoaded && mapEnabled && <GoogleMap
                          mapContainerClassName="map-container"
                          center={currentLocation}
                          zoom={10}
                        >
                          <MarkerF
                            position={currentLocation}
                            draggable={true}
                            onDragEnd={
                              (e: any) => {
                                setCurrentLatLng(e.latLng.lat(), e.latLng.lng());
                                getFormattedAddress(e.latLng.lat(), e.latLng.lng(), formik);
                              }}
                          />
                        </GoogleMap>}
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.ADDRESS] &&
                            formik.errors[REGISTRATION_FORM.ADDRESS] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.ADDRESS]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("City")}</label>
                        <Field
                          name={REGISTRATION_FORM.CITY}
                          className="email-input"
                          placeholder={t("City")}
                          value={formik.values[REGISTRATION_FORM.CITY]}
                          onBlur={formik.handleBlur}
                          onChange={(e: any) => {
                            formik.setFieldValue(REGISTRATION_FORM.CITY, e.target.value)
                          }}
                          disabled={mode === MODES.VIEW ? true : false}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.CITY] &&
                            formik.errors[REGISTRATION_FORM.CITY] && (
                              <p>
                                {t(`${formik.errors[REGISTRATION_FORM.CITY]}`)}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("State")}</label>
                        <Field
                          name={REGISTRATION_FORM.STATE}
                          className="email-input"
                          placeholder={t("State")}
                          disabled={mode === MODES.VIEW ? true : false}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.STATE] &&
                            formik.errors[REGISTRATION_FORM.STATE] && (
                              <p>
                                {t(`${formik.errors[REGISTRATION_FORM.STATE]}`)}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("Pincode")}</label>
                        <Field
                          name={REGISTRATION_FORM.PINCODE}
                          className="email-input"
                          placeholder={t("Pincode")}
                          onInput={numberOnly}
                          onPaste={numberOnly}
                          disabled={mode === MODES.VIEW ? true : false}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.PINCODE] &&
                            formik.errors[REGISTRATION_FORM.PINCODE] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.PINCODE]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("Country")}</label>
                        <Field
                          name={REGISTRATION_FORM.COUNTRY}
                          className="email-input"
                          placeholder={t(`Country code`)}
                          disabled={mode === MODES.VIEW ? true : false}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.COUNTRY] &&
                            formik.errors[REGISTRATION_FORM.COUNTRY] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.COUNTRY]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <label className="form-label">{t(userType === ADMIN_ROLES.SCHOOL ? "School ID Proof" : "University ID Proof")}</label>
                      <div className="input-btn-wrapper">
                        <input className="email-input" value={authorityDocument?.split("/")[authorityDocument?.split("/").length - 1]} disabled onClick={() => uploadDisplayImage.current?.click()} />
                        <FileUploadIcon className="upload-icon" onClick={() => uploadDisplayImage.current?.click()} />
                      </div>


                      <input
                        className="image_input"
                        type="file"
                        accept="image/png,image/jpg,image/jpeg,image/svg"
                        multiple
                        onChange={handleImageChange}
                        ref={uploadDisplayImage}
                      />
                      {authorityDocument && <div className="display-img-wrapper">
                        <img className="display-image" src={authorityDocument} onClick={() => {
                          onFilerViewerDialogOpen(authorityDocument);
                        }} />
                        <CloseIcon className="close-icon" onClick={() => { setAuthorityDocument("") }} />
                        {/* <img src={closeIcon} className="close-icon" onClick={()=>{setAuthorityDocument("")}}/> */}
                      </div>}
                    </div>
                  </div>
                  {formSubmitted && checkValueNullUndefinedEmpty(authorityDocument) && <div className="errorMessage">
                    <p>{REGISTRATION_ERRORS.AUTHORITY_REQUIRED}</p>
                  </div>}

                  <div className="bi-buttons-wrap">
                    {!GetSessionStorageData(TOKENS.TEMPORARY_TOKEN) && <button
                      className="btn bi-btn btn-back"
                      onClick={() => onNavigate(0)}
                    >
                      Back
                    </button>}
                    <button
                      className="btn bi-btn btn-next"
                      type="submit"
                      onClick={() => {
                        formik.handleSubmit();
                        setFormSubmitted(API_RESPONSE.TRUE);
                        validatePhoneNumber(
                          phoneNumber?.split("+").length > 1
                            ? phoneNumber
                            : "+" + phoneNumber
                        );
                        /* onNavigate(2) */
                      }}
                    >
                      Next
                    </button>
                  </div>

                </div>
              );
            }}
          </Formik>
        </Card>
      </div>
    </div>
  );
};

export default SchoolsUniversityBasicInformation;